import classNames from 'classnames';
import { ControlProps, RadioBoxProps, RadioBoxRadioProps, RadioButton, RadioButtonProps } from 'lego-on-react';
import * as React from 'react';
import { ReactNode } from 'react';

import { Bem } from '../../service/Bem/Bem';

import './RadioButtonDecorator.css';

export type RadioButtonDecoratorProps = RadioButtonProps &
    RadioBoxProps & {
        valid?: boolean;
        children: ReactNode;
    };

const blockClass = 'radio-button-decorator';

export function RadioButtonDecorator(props: RadioButtonDecoratorProps): JSX.Element {
    const { cls, valid = true, children, ...passThroughProps } = props;

    return (
        <div
            className={classNames(
                Bem.cls({
                    block: blockClass,
                    mods: { invalid: !valid }
                }),
                cls
            )}
        >
            <RadioButton {...passThroughProps}>{children}</RadioButton>
        </div>
    );
}

export function RadioItemDecorator(
    props: ControlProps &
        RadioBoxRadioProps & {
            children: ReactNode;
            cls?: string;
            value: string | number;
        }
): JSX.Element {
    const { cls, children, ...passThroughProps } = props;

    return (
        <RadioButton.Radio cls={classNames(Bem.cls(blockClass, 'radio'), cls)} {...passThroughProps}>
            {children}
        </RadioButton.Radio>
    );
}
